import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { setQuestion } from '../actions/question.actions';
import { Candidate } from '../models/candidate.model';
import { Question } from '../models/question.model';

export const initialState: Question = null;

const reducer = createReducer(initialState,
  // on(setQuestion, (state, question) => { return question})
  on(setQuestion, (state, questions) => questions)
);

export const fromQuestion = {
  selectQuestionState: createFeatureSelector<Question>('questions'),
};

export function questionReducer(state, action) {
  return reducer(state, action);
}
